import script from "./ArticleEditDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticleEditDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ArticleEditDialog.vue?vue&type=style&index=0&id=632d4e40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632d4e40"]])

export default __exports__